import {
  FETCH_SHOPPINGS,
  FETCH_FEATURE_SHOPPINGS,
  FETCH_RELATION_SHOPPINGS,
  FETCH_SAME_CATEGORY_SHOPPINGS,
  FETCH_FAVORITED_SHOPPINGS,
  FETCH_SHOPPING,
  ERROR_SHOPPING,
  RESET_SHOPPINGS
} from '@/actions/actionTypes';
import {
  fetchShoppingsEntries,
  fetchFeatureShoppingsEntries,
  fetchSameCategoryShoppingsEntries,
  fetchFavoritedShoppingsEntries,
  fetchShoppingEntry
} from '@/domains/contentful/shopping';
import { IShopping } from '@/@types/generated/contentful';
import { AppDispatch } from '@/store/configureStore';
import _ from 'lodash';

/**
 * Action Creator
 */
export const innerFetchShoppings = (shoppingList: IShopping[]) => ({
  type: FETCH_SHOPPINGS,
  payload: {
    shoppingList
  }
});

export const innerFetchFeatureShoppings = (shoppingList: IShopping[]) => ({
  type: FETCH_FEATURE_SHOPPINGS,
  payload: {
    shoppingList
  }
});

export const innerFetchRelationShoppings = (shoppingList: IShopping[]) => ({
  type: FETCH_RELATION_SHOPPINGS,
  payload: {
    shoppingList
  }
});

export const innerFetchSameCategoryShoppings = (shoppingList: IShopping[]) => ({
  type: FETCH_SAME_CATEGORY_SHOPPINGS,
  payload: {
    shoppingList
  }
});

export const innerFetchFavoritedShoppings = (shoppingList: IShopping[]) => ({
  type: FETCH_FAVORITED_SHOPPINGS,
  payload: {
    shoppingList
  }
});

export const innerFetchShopping = (shopping: IShopping) => ({
  type: FETCH_SHOPPING,
  payload: {
    shopping
  }
});

export const innerErrorShopping = () => ({
  type: ERROR_SHOPPING
});

export const innerResetShoppings = () => ({
  type: RESET_SHOPPINGS
});

/**
 * Action
 */
export const fetchShoppings = () => async (dispatch: AppDispatch) => {
  const shoppingList = await fetchShoppingsEntries();
  dispatch(innerFetchShoppings(shoppingList));
};

export const fetchFeatureShoppings = (feature: string) => async (dispatch: AppDispatch) => {
  const shoppingList = await fetchFeatureShoppingsEntries(feature);
  dispatch(innerFetchFeatureShoppings(shoppingList));
};

export const fetchRelationShoppings = (relationShoppingList?: IShopping[]) => async (
  dispatch: AppDispatch
) => {
  if (!relationShoppingList || relationShoppingList.length === 0) return;
  dispatch(innerFetchRelationShoppings(relationShoppingList));
};

export const fetchSameCategoryShoppings = ({
  shoppingCat,
  shoppingId
}: {
  shoppingCat: string;
  shoppingId: string;
}) => async (dispatch: AppDispatch) => {
  const shoppingList = await fetchSameCategoryShoppingsEntries({ shoppingCat, shoppingId });
  dispatch(innerFetchSameCategoryShoppings(shoppingList));
};

export const fetchFavoritedShoppings = (favoritedList: string[]) => async (
  dispatch: AppDispatch
) => {
  const shoppingList = await fetchFavoritedShoppingsEntries(favoritedList);
  await dispatch(innerFetchFavoritedShoppings(shoppingList));
};

export const fetchShopping = (slug?: string | string[]) => async (dispatch: AppDispatch) => {
  if (!slug || _.isArray(slug)) return;
  const shopping = await fetchShoppingEntry(slug);
  if (!shopping) {
    dispatch(innerErrorShopping());
    return;
  }
  dispatch(innerFetchShopping(shopping));
};

export const resetShoppings = () => async (dispatch: AppDispatch) => {
  dispatch(innerResetShoppings());
};
